import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, CircularProgress, IconButton, Toolbar, Typography } from '@mui/material';
import { FC } from 'react';

import { CameraPicker } from '@components/CameraPicker';
import { DialogDarkFullscreen } from '@components/DialogDarkFullscreen';

import { sxAppBar, sxTitle, sxTopControls, sxVideoContainer, videoStyle } from './styles';
import { useQrCamera } from './hooks/useQrCamera';

type QrScannerDialogProps = {
  open: boolean;
  title: string;
  onClose: VoidFunction;
  onQrCodeRecognized: (qrData: string) => void;
  loading?: boolean;
  disableCloseButton?: boolean;
};

const QrScannerDialog: FC<QrScannerDialogProps> = ({
  open,
  title,
  onClose,
  onQrCodeRecognized,
  loading = false,
  disableCloseButton = false,
}) => {
  const { cameraDevices, setVideoRef, handleCameraChange } = useQrCamera({
    open,
    onScan: onQrCodeRecognized,
  });

  const isVideoVisible = open && !loading;

  return (
    <DialogDarkFullscreen open={open} onClose={onClose}>
      <AppBar sx={sxAppBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            disableRipple
            disabled={disableCloseButton}
            aria-label="Close scanner"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>

          <Typography sx={sxTitle} variant="h6" component="div">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={sxVideoContainer}>
        {!isVideoVisible ? (
          <CircularProgress />
        ) : (
          <>
            <Box sx={sxTopControls}>
              <Box />
              <CameraPicker cameras={cameraDevices} onCameraChange={handleCameraChange} />
            </Box>

            <video ref={setVideoRef} playsInline style={videoStyle}>
              <track kind="captions" />
            </video>
          </>
        )}
      </Box>
    </DialogDarkFullscreen>
  );
};

export default QrScannerDialog;
